<template>
  <div id="new-plans">
    <b-row class="mt-4" v-if="loadingData && !loadError">
      <b-col
        cols="12"
        md="6"
        lg="6"
        xl="4"
        v-for="item in 3"
        :key="item"
        class="mb-4"
      >
        <b-progress
          variant="primary"
          :max="100"
          class="w-100"
          show-progress
          animated
          height="200px"
        >
          <b-progress-bar :value="100">Loading...</b-progress-bar>
        </b-progress>
      </b-col>
    </b-row>
    <b-row v-else-if="loadError" class="mt-4" align-v="stretch">
      <b-col cols="12" class="mb-4">
        <div class="text-center" title="Could not load, click on retry">
          <b-button
            class="w-100"
            style="height:200px"
            size="sm"
            @click="loadPackages()"
            variant="light"
          >
            <bad-network-icon />
            <br />Error Loading Data, <br />click to retry
            <reload-icon class="ml-1" />
          </b-button>
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-4" v-else align-v="stretch">
      <b-col
        class="mb-5"
        cols="12"
        md="6"
        lg="6"
        xl="4"
        v-for="item in packages"
        :key="item.id"
        :order="item.slug == 'co-ownership' ? '1' : '2'"
      >
        <div class="wrap dash-card bg-white position-relative">
          <div class="wrap p-4 mt-2">
            <div
              class="dash-card bg-dark shadow-xl text-white"
              style="height:150px; padding:70px 20px; margin-bottom:20px"
              :style="{
                backgroundImage:
                  ` linear-gradient(0deg, rgba(0,0,0,0.6), transparent), url(` +
                  farm_img +
                  `)`
              }"
            >
              <h5 class="mb-0 mr-2">{{ item.location.locationname }} Farm</h5>
              <h6 class="d-inline-block mb-0 mr-2">
                {{ item.plotsize }}
              </h6>
            </div>

            <!-- <hr /> -->
            <b-row class="mt-1">
              <b-col>
                <h5 class="text-primary">
                  {{ formatMoney(item.price) }}
                  <span
                    class="font-weight-normal ml-1 text-dark"
                    style="font-size:16px"
                    >/ plot / per annum</span
                  >
                </h5>

                <div class="text-center mm-text">
                  Rent this fertile farmland and then employ us to <b>farm for you</b>. You Rent, We Farm, You Earn.
                </div>

              </b-col>
            </b-row>
          </div>
          <hr class="mt-0" />
          <div class="wrap px-4 pb-4">
            <b-row no-gutters>
              <b-col cols="12" v-if="item.status == 1">
                <b-button
                  variant="primary"
                  class="w-100 btn-sm"
                  @click="handleInvest(item)"
                  >Rent Farm</b-button
                >
              </b-col>
              <b-col cols="12" v-if="item.status == 0">
                <b-button variant="danger" class="w-100 btn-sm"
                  >Sold Out</b-button
                >
              </b-col>
            </b-row>
          </div>
        </div>
      </b-col>
    </b-row>
    <pre>
          <!-- {{ packages }} -->
     </pre>
  </div>
</template>

<script>
import { TransactionService } from "@/services";
import { formatMoney, formatPercent } from "@/utils/helpers";
import loadData from "@/mixins/loadData";
import InvestDrawer from "./InvestDrawer";
import InvestInfoDrawer from "./InvestInfoDrawer";

export default {
  data() {
    return {
      packages: [],
      farm_img:
        "https://agbeloba-media.s3.amazonaws.com/057a2dc9-9714-40ad-8482-abf38fd629ca.jpg"
    };
  },
  mixins: [loadData],

  methods: {
    formatMoney,
    async loadPackages() {
      this.loadingData = true;
      this.loadError = false;
      try {
        const { data } = await TransactionService.getActivePackages();
        let packageList = data.farmpackages;

        // Convert for Options
        const packages = {};
        const packagesROI = {};

        //add placeholder to force users to select a package
        packages[0] = "Select a Package";
        packagesROI[0] = 0;

        packageList.forEach(ele => {
          if (ele.type == "rental") {
            this.packages.push(ele);

            packages[ele.id] = `${ele.packagename} - ${
              ele.duration
            } months - ${formatPercent(ele.roi / 100)}`;
            packagesROI[ele.id] = Number(ele.roi) / 100;
          }
        });
        //this.packages = packageList;
        this.packagesROI = packagesROI;
      } catch (err) {
        this.loadError = true;
      } finally {
        this.loadingData = false;
      }
    },
    handleInvest(invPackage) {
      const panelResult = this.$showPanel({
        component: InvestDrawer,
        openOn: "right",
        width: "400px",
        disableBgClick: true,
        props: {
          invPackage: invPackage
        }
      });

      panelResult.promise.then(result => {
        if (result.closedBy != "bg") {
          this.$emit("setActiveTab");
        }

        //result is the value passed from your component calling this.$emit('close-panel', //some value);
      });
    },
    handleAbout(invPackage) {
      const panelResult = this.$showPanel({
        component: InvestInfoDrawer,
        openOn: "right",
        width: "400px",
        props: {
          invPackage: invPackage
        }
      });

      panelResult.promise.then(result => {
        if (result.invest) {
          setTimeout(() => {
            return this.handleInvest(result.invPackage);
          }, 1000);
        }
        if (result.closedBy != "bg") {
          this.$emit("setActiveTab");
        }
        //result is the value passed from your component calling this.$emit('close-panel', //some value);
      });
    }
  },
  mounted() {
    this.loadPackages();
  }
};
</script>

<style>
h6 {
  text-transform: capitalize;
}
</style>
